import type { HandwritingElements } from "./handwriting-markup.js";
import type { SearchBox } from "./search-box.js";

/**
 * The search box behind the dialog, as the reader sees it from inside.
 *
 * Taking a character leaves the pad open, so the box fills up out of sight and
 * these two are how a reader follows what they have built. A 词典 query is
 * usually two characters, and hunting for the pen again between 汉 and 字 is
 * what this arrangement is avoiding.
 */

/**
 * Puts the box's contents on the line beside the search button.
 *
 * The button goes with it. An empty box is nothing to search for, and a button
 * that does nothing is worse than one that says it will not.
 */
export function showQuery(elements: HandwritingElements, box: SearchBox): void {
  const query = box.input.value;

  elements.query.textContent = query === "" ? "" : `Searching for ${query}`;
  elements.search.disabled = query === "";
}

/**
 * Adds one character to the box.
 *
 * The `input` event is what the suggestions under the box listen for, so a
 * reader who has drawn 汉 is offered 汉字 and 汉语 without typing anything.
 */
export function addToQuery(box: SearchBox, character: string): void {
  box.input.value += character;
  box.input.dispatchEvent(new Event("input", { bubbles: true }));
}
